import React, { useEffect, useState } from 'react';
import { LinearProgress, Typography } from '@mui/material';
import { formatDateTime } from '../../../components/ex_dayjs';
import { dataProvider } from '../../../DataProvider';
import { Confirm, useNotify } from 'react-admin';
import MDialog from '../../../components/controls/MDialog';
import { Box } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';

interface IData {
    [key: string]: any;
}

const MappingEvent: React.FC<IData> = (props) => {
    const notify = useNotify();
    const { mapEvent, setMapEvent, api } = props;
    const { open, searchData } = mapEvent;
    const [matchEvent, setMatchEvent] = useState<any[]>([]);
    const [selectEvent, setSelectEvent] = useState(null);
    const _fullExchangeMarket = [
        { id: 1, name: 'Vivid' },
        { id: 2, name: 'TicketNetwork' },
        { id: 3, name: 'StubHub' },
        { id: 4, name: 'SeatGeek' },
        { id: 5, name: 'TickPick' },
        { id: 13, name: 'GoTickets' }
    ];

    useEffect(() => {
        if (open === false) return;
        setMapEvent(prev => ({ ...prev, isLoading: true }));
        //filter event
        let postData = {
            event_date: searchData.event_date,
            section: searchData.section,
            row: searchData.row,
            seats: searchData.seats
        };
        dataProvider.postData('ListingVisibility', 'GetMatchEvent', postData)
            .then((response: any) => {
                if (response?.data) {
                    let formatData = response.data.map((x: any) => ({ ...x, id: x.sm_listing_id + '-' + x.market_id + '-' + x.account_id }));
                    // eslint-disable-next-line eqeqeq -- market_id may arrive as a numeric string from GetMatchEvent; loose match tolerates both
                    setMatchEvent(formatData.filter((x: any) => x.market_id == mapEvent.marketId));
                } else {
                    if (response.message)
                        notify(`Error: ${response?.message}`, { type: 'error', autoHideDuration: 5000 });
                    else
                        notify(`Error happened. Try to reload page. ${response}`, { type: 'error', autoHideDuration: 5000 });
                }
            })
            .catch((err: any) => {
                notify(`Something went wrong. ${err}`, { type: 'error', autoHideDuration: 5000 });
            })
            .finally(() => setMapEvent(prev => ({ ...prev, isLoading: false })));
    }, [open]);



    const columnDefs = [
        { field: 'sm_listing_id', headerName: 'Sm ListingID', width: 110 },
        { field: 'event', headerName: 'Event', width: 280 },
        { field: 'venue', headerName: 'Venue', width: 280 },
        {
            field: 'event_date',
            headerName: 'DateTime',
            width: 100,
            valueGetter: (params) => formatDateTime(params)
        },
        { field: 'section', headerName: 'Section', width: 130 },
        { field: 'row', headerName: 'Row', width: 80 },
        { field: 'seats', headerName: 'Seats', width: 80 },
        {
            field: 'price',
            headerName: 'Price',
            width: 70,
            align: 'right',
            headerAlign: 'right'
        },
    ];

    const handleClose = (_params) => {
        clearData();
    };

    const handleSave = async () => {
        setMapEvent(prev => ({ ...prev, isLoading: true }));

        let postData = matchEvent.find((x: any) => x.id === selectEvent);
        postData.inventory_id = searchData.id;
        await dataProvider.postData('ListingVisibility', 'MapEvent', postData)
            .then((response: any) => {
                if (response?.data) {
                    //refresh updated row
                    let grid_data = api.getModel().rowsToDisplay?.reduce((flatArr: any, obj: any) => {
                        flatArr.push(obj.data);
                        return flatArr;
                    }, []);

                    let selectRow = grid_data.find((r: any) => r.id === searchData.id);
                    selectRow[mapEvent.marketId === 3 ? 'sh_listing_id' : 'vs_listing_id'] = selectEvent.split('-')[0];
                    selectRow[mapEvent.marketId === 3 ? 'sh_shown' : 'vs_shown'] = postData.is_shown;
                    selectRow[mapEvent.marketId === 3 ? 'sh_price' : 'vs_price'] = postData.price;
                    selectRow[mapEvent.marketId === 3 ? 'sh_map_price' : 'vs_map_price'] = postData.map_price;
                    selectRow[mapEvent.marketId === 3 ? 'sh_url' : 'vs_url'] = postData.sm_event_url;
                    api.setRowData(grid_data);
                    api.forEachNode((node) => {
                        if (node.data.id === searchData.id) {
                            node.setSelected(true);
                        }
                    });
                    //
                    notify('Success', { type: 'success', autoHideDuration: 2000 });
                } else {
                    if (response.message)
                        notify(`Error: ${response?.message}`, { type: 'error', autoHideDuration: 5000 });
                    else
                        notify(`Error happened. Try to reload page. ${response}`, { type: 'error', autoHideDuration: 5000 });
                }
            })
            .catch((err: any) => {
                notify(`Something went wrong. ${err}`, { type: 'error', autoHideDuration: 5000 });
            })
            .finally(() => {
                clearData();
            });
    };

    function clearData () {
        setMapEvent(prev => ({ ...prev, isLoading: false, open: false }));
        setSelectEvent(null);
        setMatchEvent([]);
    }

    return (
        <>
            <MDialog
                maxWidth={'lg'}
                open={open}
                handleClose={handleClose}
                title={`Select events for mapping ${mapEvent.marketId === 3 ? 'StubHub' : 'Vivid'}`}
                className={'listing-visibility-merge-dialoge'}
                // disabled={disable}
                children={
                    <>
                        {mapEvent.isLoading && <LinearProgress color="secondary" />}
                        <Box sx={{ height: matchEvent.length > 0 ? '60vh' : 135, width: '100%' }}>
                            <DataGrid
                                // apiRef={apiRef}
                                rows={matchEvent}
                                columns={columnDefs}
                                onRowDoubleClick={(params, _ev) => {
                                    setSelectEvent(params.id);
                                    setMapEvent(prev => ({ ...prev, openCfm: true }));
                                }}
                                getRowHeight={() => 'auto'}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 25,
                                        },
                                    },
                                }}
                            />
                            <Typography color='secondary' variant='caption'>Double click row to select</Typography>
                        </Box>
                    </>
                }

            />
            {!!selectEvent && <Confirm isOpen={mapEvent.openCfm}
                title='Confirm matching?'
                content={
                    <div>- Event: <mark className='mark1'>{matchEvent.find((x: any) => x.id === selectEvent).event}</mark> with <mark className='mark1'>{searchData.event}</mark>
                        <br /><br /> - Venue: <mark className='mark2'>{matchEvent.find((x: any) => x.id === selectEvent).venue}</mark> with <mark className='mark2'>{searchData.venue}</mark></div>
                }
                onClose={() => setMapEvent((prev) => ({ ...prev, openCfm: false }))}
                onConfirm={() => {
                    setMapEvent((prev) => ({ ...prev, openCfm: false }));
                    handleSave();
                }} />
            }
        </>


    );
};
export default React.memo(MappingEvent);